<template>
  <kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
      <div class="card" style="overflow:inherit">
        <div class="card-header bg-transparent" id="headingOne">
          <div class="card-title collapsed" data-toggle="collapse"
               data-target="#filterForm"
               aria-controls="filterForm">
            {{ $t('label.search') }}
          </div>
        </div>
        <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
          <div class="card-body">
            <form @submit.prevent="action($event, query)">
              <kt-form-section>
                <kt-form-row>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="user_id">
                        {{ $t('label.user_id') }}
                      </kt-form-label>
                      <kt-form-control ref="user_id" dir="ltr" name="phone" id="user_id" v-model="query.user_id" />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="phone">
                        {{ $t('label.phone') }}
                      </kt-form-label>
                      <kt-form-control ref="phone" dir="ltr" name="phone" id="phone" v-model="query.phone" />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="full_name">
                        {{ $t('label.full_name') }}
                      </kt-form-label>
                      <kt-form-control ref="full_name" name="full_name" id="full_name" v-model="query.full_name"></kt-form-control>
                    </kt-form-group>
                  </kt-col>

                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="pattern_name">
                        {{ $t('label.pattern_name') }}
                      </kt-form-label>
                      <kt-form-control ref="pattern_name" name="pattern_name" id="pattern_name" v-model="query.pattern_name"></kt-form-control>
                    </kt-form-group>
                  </kt-col>

                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="type">
                        {{ $t('label.type') }}
                      </kt-form-label>
                      <select id="type" name="type" class="form-control" v-model="query.type">
                        <option :value="null">همه</option>
                        <option v-for="item in notificationTypes" :key="item.value" :value="item.value">
                          {{ item.label }}
                        </option>
                      </select>
                    </kt-form-group>
                  </kt-col>

                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="status_code">
                        {{ $t('label.status_code') }}
                      </kt-form-label>
                      <kt-form-control ref="status_code" name="status_code" id="status_code" v-model="query.status_code"></kt-form-control>
                    </kt-form-group>
                  </kt-col>

                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="from_date">
                        {{ $t('reports.tax.from_date') }}
                      </kt-form-label>
                      <button id="reset_from_date"
                              @click="clearFromDate"
                              class=" btn btn-label-danger trash-btn"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          input-class="form-control"
                          id="from_date"
                          name= "from_date"
                          v-model="query.from_date"
                          type="datetime" />
                    </kt-form-group>

                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="to_date">
                        {{ $t('reports.tax.to_date') }}
                      </kt-form-label>
                      <button id="reset_to_date"
                              @click="clearToDate"
                              class=" btn btn-label-danger trash-btn"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          input-class="form-control"
                          id="to_date"
                          name= "to_date"
                          v-model="query.to_date"
                          type="datetime"
                      />
                    </kt-form-group>
                  </kt-col>
                </kt-form-row>
              </kt-form-section>
              <kt-form-section>
                <kt-row>
                  <kt-col xs="12" sm="6" md="6">
                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                  </kt-col>
                </kt-row>
              </kt-form-section>
            </form>
          </div>
        </div>
      </div>
    </div>
  </kt-panel>
</template>

<script>
import $ from 'jquery'
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { shahkarInquiryStatus, shahkarInquiryStatusStr } from '@/constants/shahkarInquiryStatus'
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'
import { userAccessType, userAccessTypeStr } from '@/constants/UserAccessType'
import { RolesArray } from '@/constants/RoleAndPermissions'
import {i18n} from "@/plugins/i18n";

export default {
  props: {
    action: {
      default: function(e, query) {},
      required: true,
    },
  },
  computed: {
    permissions() {
      return RolesArray.map(role => {
        return role.permissions.map(permission => {
          return {
            'name': role.name + ' - ' + permission.name,
            'value': permission.key,
          }
        })
      }).flat()
    }
  },
  data() {
    return {
      notificationTypes: [
        { value: 'kavenegar-sms-lookup', label: this.$t('notification.types.kavenegar_sms_lookup') },
        { value: 'kavenegar-sms-send',   label: this.$t('notification.types.kavenegar_sms_send') },
        { value: 'kavenegar-call-lookup', label: this.$t('notification.types.kavenegar_call_lookup') },
        { value: 'kavenegar-call',        label: this.$t('notification.types.kavenegar_call') },
        { value: 'mobin-sms-pattern',     label: this.$t('notification.types.mobin_sms_pattern') },
        { value: 'mobin-sms-send',        label: this.$t('notification.types.mobin_sms_send') },
        { value: 'mobin-votp',            label: this.$t('notification.types.mobin_votp') },
        { value: 'telegram-bot',          label: this.$t('notification.types.telegram_bot') },
      ],
      userAccessType: userAccessType,
      userAccessTypeStr: userAccessTypeStr,
      shahkar_inquiry_statuses: [
        {
          name: null,
          value: null
        },
        {
          name: shahkarInquiryStatusStr.PENDING,
          value: shahkarInquiryStatus.PENDING
        },
        {
          name: shahkarInquiryStatusStr.CONFIRMED,
          value: shahkarInquiryStatus.IS_MATCHED
        },
        {
          name: shahkarInquiryStatusStr.REJECTED,
          value: shahkarInquiryStatus.IS_NOT_MATCHED
        },
      ],
      statuses: [
        {
          name: null,
          value: null
        },
        {
          name: userStatusStr.ACTIVE,
          value: userStatus.ACTIVE
        },
        {
          name: userStatusStr.REMOVED,
          value: userStatus.REMOVED
        },
        {
          name: userStatusStr.PENDING,
          value: userStatus.PENDING
        },
        {
          name: userStatusStr.IS_AUTHENTICATED,
          value: userStatus.IS_AUTHENTICATED
        },
        {
          name: userStatusStr.IS_AUTHENTICATED_PENDING,
          value: userStatus.IS_AUTHENTICATED_PENDING
        },
        {
          name: userStatusStr.AUTHORIZATION_DOCUMENTS_REJECTED,
          value: userStatus.AUTHORIZATION_DOCUMENTS_REJECTED
        },
        {
          name: userStatusStr.ENAMAD_AUTHENTICATED,
          value: userStatus.ENAMAD_AUTHENTICATED
        },
        {
          name: userStatusStr.TEMPORARY_BLOCK,
          value: userStatus.TEMPORARY_BLOCK
        },
        {
          name: userStatusStr.USER_INQUIRY_REJECTED,
          value: userStatus.USER_INQUIRY_REJECTED
        },
        {
          name: userStatusStr.DEACTIVATED,
          value: userStatus.DEACTIVATED
        },
      ],
      gateway_statuses: [
        {
          name: '',
          value: ''
        },
        {
          name: gatewayStatusStr.ACTIVE,
          value: gatewayStatus.ACTIVE
        },
        {
          name: gatewayStatusStr.PENDING,
          value: gatewayStatus.PENDING
        },
        {
          name: gatewayStatusStr.SEND_TO_SHAPARAK,
          value: gatewayStatus.SEND_TO_SHAPARAK
        },
        {
          name: gatewayStatusStr.REJECTED,
          value: gatewayStatus.REJECTED
        },
        {
          name: gatewayStatusStr.HAS,
          value: gatewayStatus.HAS
        },
        {
          name: gatewayStatusStr.DOES_NOT_HAVE,
          value: gatewayStatus.DOES_NOT_HAVE
        },
        {
          name: gatewayStatusStr.DIRECT_TO_PSP,
          value: gatewayStatus.DIRECT_TO_PSP
        },
      ],
      query: {
        user_access: [],
        type: null,
      },
    }
  },
  mounted() {
    setTimeout( () => {
      $('.kt-selectpicker').selectpicker({
        size: 4,
        liveSearch: true,
        noneResultsText: i18n.t('selectpicker.none_result'),
        selectAllText: i18n.t('selectpicker.select_all'),
        noneSelectedText: i18n.t('selectpicker.nothing_selected')
      })
    }, 1500)
  },

  methods: {
    clearFromDate() {
      if(this.query.from_date) {
        this.query.from_date = null
      }
    },
    clearToDate() {
      if(this.query.to_date) {
        this.query.to_date = null
      }
    },
  }

}
</script>

<style>

</style>